import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import c from 'classnames'

import { getHasLesaVDP } from 'selectors/appStatusSelectors'

export const LESA_VDP_SCRIPT_SRC =
  'https://www.idostream.com/member/les_video_vdp.js'

export const injectScript = () => {
  let d = window.document,
    lastScript = d.getElementsByTagName('script')[0],
    lesaTag = d.createElement('script')

  lesaTag.async = true
  lesaTag.language = 'javascript'
  lesaTag.src = LESA_VDP_SCRIPT_SRC

  lastScript.parentNode.insertBefore(lesaTag, lastScript)
}

export function LesaVDP({ show, vin, className }) {
  useEffect(() => {
    show && injectScript()
  }, [show])

  if (!show) return null

  return (
    <div
      les_vin={vin}
      className={c('frikin-lesa-wrapper', 'les_video', className)}
    />
  )
}

function mapStateToProps(state, op) {
  return {
    ...op,
    show: getHasLesaVDP(state),
  }
}

export default connect(mapStateToProps)(LesaVDP)

/*
 *  LESA vdp widget
 *
 *  if feature is turned on in helixe, this widget will show up as the first
 *  node in the vehicle gallery on the customer view. Original docs below:
 *
 *  Please add the following line of code on the Vehicle Details Page below the photos (if possible):
 *
 *  <div class="les_video" les_vin="{VIN}"></div>		EG. <div class="les_video" les_vin="1ABCD5A69AB123456"></div>
 *
 *  Then add the following line code anywhere after the above line of code.
 *
 *  <script async src="https://www.idostream.com/member/les_video_vdp.js" language="javascript"></script>
 *
 *  Note: The curly brackets around the {VIN} represent the VIN number that should populate on run time(dynamic VIN).  Do not include the brackets { } in the script"
 *
 *  There are custom styles in Gallery.scss to account for the responsive height
 *  of the iframe generated
 */
